import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=ec9bf310&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec9bf310')) {
      api.createRecord('ec9bf310', component.options)
    } else {
      api.reload('ec9bf310', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=ec9bf310&", function () {
      api.rerender('ec9bf310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Cf3Ey87TF7x/JS/comp/IncreaseNumber.vue"
export default component.exports